export default __webpack_public_path__ + "static/media/wolframalpha.e6299b2d.svg";